// PDF Document Constants

export const PDF_DOCUMENT_CONSTANTS = {
  // Section identifiers used in checkedItems
  SECTIONS: {
    COVER_PAGE: 'cover-page',
    TABLE_OF_CONTENT: 'table-of-content',
    LAMP_INFO: 'lamp-info',
    LAYERS_SUMMARY: 'layers-summary',
    GRAPHS: 'graphs',
    GLOBAL_PLOTS: 'global-plots',
  },

  // ID patterns for dynamic content
  IDS: {
    COVER_PAGE: 'cover-page',
    TABLE_OF_CONTENT: 'table-of-content',
    LAYERS_SUMMARY: 'layers-summary',
    LAMP_INFO_PREFIX: 'lamp-info-',
    GRAPHS_PREFIX: 'graphs-',
    GLOBAL_PLOTS: 'global-plots',
  },

  // Page styling
  PAGE: {
    SIZE: 'A4' as const,
    FONT_SIZE: 12,
    PADDING_TOP: 80,
    PADDING_BOTTOM: 45,
  },

  // Chapter numbers
  CHAPTERS: {
    COVER_PAGE: '1.',
    TABLE_OF_CONTENT: '2.',
    LAMP_INFO_PREFIX: '3.1.',
    LAYERS_SUMMARY: '4.',
    GRAPHS_PREFIX: '5.1.',
  },

  // Lamp specifications
  LAMP: {
    MANUFACTURER: 'TAMAN',
  },

  // Labels
  LABELS: {
    MANUFACTURER: 'Manufacturer',
    LAMP_ID: 'Lamp ID',
    LAMP_NAME: 'Lamp name',
    LUMEN_OUTPUT: 'Total lumen output',
    HEIGHT: 'Height (distance to ground)',
    POSITION_X: 'X coordinate',
    POSITION_Y: 'Y coordinate',
    POSITION_Z: 'Z coordinate',
    LATITUDE: 'Latitude',
    LONGITUDE: 'Longitude',
    PLACEHOLDER: '--',
  },

  // Page titles
  TITLES: {
    COVER: 'Cover',
    CONTENT: 'Table of Contents',
    LAYERS_SUMMARY: 'Layers Summary',
    GLOBAL_PLOTS: 'Global Plots',
  },

  // Measurement values
  MEASUREMENTS: {
    MAINTENANCE_FACTOR_DESCRIPTION: 'A maintenance factor of 0.80 was used for the installation calculation.', // TODO this is wrong, fix in another PR
  },

  // Page calculation
  PAGE_OFFSET: {
    COVER_PAGE_OFFSET: 1,
    TABLE_OF_CONTENT_OFFSET: 1,
  },
} as const;
